const ContactReasons = {
    teacherTraining: "Teacher Training",
    kinderBeatLicence: "Kinder Beat Licensing",
    encoreLicence: "Encore on Keys Licensing",
    other: "Other"
}

Object.freeze(ContactReasons);

export default ContactReasons